import { typeOfPAF } from "../../../../constants/typeOfPAF";

/**
 * Step 6 / review field validity (mirrors legacy `validateFields` in the page).
 */
export function validatePatientInitiationFields(
  {
    patient_initials = "",
    patient_dob = "",
    indication,
    indication_other = "",
    clinical_trial = "",
    number_cycles = "",
    prescriber_name = "",
    hospital_name_and_address = "",
    date_paper_paf = "",
    confirmation_other1 = "",
    confirmation_other2 = "",
    confirmation_risk_prescriber = "",
    confirmation_risk_patient = "",
  },
  {
    isPrescriber,
    isConnectedRegistrar,
    isPharmacy,
    prescriptionField,
    registerPatientType,
    allCheckedPrescriber,
  }
) {
  return {
    patient_initials: {
      isValid: patient_initials.trim().length > 0,
    },
    patient_dob: {
      isValid: !!patient_dob,
    },
    indication_other: {
      isValid: !indication?.label?.includes("Other")
        ? true
        : indication_other?.trim().length > 0,
    },
    clinical_trial: {
      isValid: !indication?.label?.includes("Clinical")
        ? true
        : clinical_trial?.trim().length > 0,
    },
    prescriber_name: {
      isValid:
        isPrescriber || isConnectedRegistrar
          ? true
          : prescriber_name.trim().length > 0,
    },
    hospital_name_and_address: {
      isValid: isPharmacy ? !!hospital_name_and_address : true,
    },
    date_paper_paf: {
      isValid: isPharmacy ? !!date_paper_paf : true,
    },
    confirmation_other1: {
      isValid: isPharmacy ? !!confirmation_other1 : true,
    },
    confirmation_other2: {
      isValid: isPharmacy ? !!confirmation_other2 : true,
    },
    confirmation_risk_prescriber: {
      isValid:
        registerPatientType === typeOfPAF.WOMANOFNCP
          ? true
          : prescriptionField?.prescriber_confirmations?.length > 0
            ? !!allCheckedPrescriber
            : !!confirmation_risk_prescriber,
    },
    confirmation_risk_patient: {
      isValid: isPharmacy
        ? true
        : registerPatientType === typeOfPAF.WOMANOFNCP
          ? true
          : true,
    },
  };
}
